// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'vend... Remove this comment to see the full error message
import createStore from 'vendor/cnpm/fluxible.v0-4/addons/createStore';

const CourseCreationMessageStore = createStore({
  storeName: 'CourseCreationMessageStore',

  initialize() {
    this.courseCreationErrorMessage = null;
  },

  getCourseCreationErrorMessage() {
    return this.courseCreationErrorMessage;
  },
});

CourseCreationMessageStore.handlers = {
  UPDATE_COURSE_CREATION_ERROR_MESSAGE(courseCreationErrorMessage: JSX.Element) {
    this.courseCreationErrorMessage = courseCreationErrorMessage;
    this.emitChange();
  },
};

export default CourseCreationMessageStore;
